import { __module as isDefined } from '../../../../../_virtual/is-defined.js';

var hasRequiredIsDefined;

function requireIsDefined () {
	if (hasRequiredIsDefined) return isDefined.exports;
	hasRequiredIsDefined = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isDefined;
		/**
		 * Check if a value is defined
		 * @ignore
		 * @param {*} value
		 * @return {boolean}
		 */
		function isDefined(value) {
		  return value !== undefined && value !== null;
		}
		module.exports = exports["default"];
		
	} (isDefined, isDefined.exports));
	return isDefined.exports;
}

export { requireIsDefined as __require };
